const enum Keys {
  INFO_SHOULD_DISPLAY_HELPER = 'info.shouldDisplayHelper',
  CAREGIVERS_DIRECTORY_SHOULD_DISPLAY_HELPER = 'caregiversDirectory.shouldDisplayHelper',
  TRACKING_SURVEY_SHOULD_ASK_FOR_REMINDER = 'tracking.survey.shouldAskForReminder',
  TRACKING_SURVEY_SHOULD_ASK_FOR_PERIOD = 'tracking.survey.shouldAskForPeriod',
  TRACKING_SHOULD_DISPLAY_HELPER = 'tracking.shouldDisplayHelper',
  TRACKING_REMINDER_TIME = 'tracking.reminder.time', // symptom tracking daily reminder
  TRACKING_ENABLE_PERIOD_REMINDER = 'tracking.reminder.isPeriodReminderEnabled',
  TRACKING_DID_WE_ALREADY_SUGGEST_PERIOD_REMINDER = 'tracking.reminder.didWeAlreadySuggestPeriodReminder',
  PAYWALL_DID_ENABLE_FREE_MESSAGES = 'paywall.didEnableFreeMessages',
}

export default Keys;
